__turbopack_context__.v({
  "disabled": "_9QMWYq_disabled",
  "footer": "_9QMWYq_footer",
  "icon": "_9QMWYq_icon",
  "placeholder": "_9QMWYq_placeholder",
});
